import { useState } from 'react';
import { useBetween } from 'use-between';

const usePromptState = () => {
  const [promptVolunteerId, setPromptVolunteerId] = useState<string>('');
  const [promptSessionId, setPromptSessionId] = useState<string>('');
  const [hidePromptForDate, setHidePromptForDate] = useState<boolean>(false);
  // Track if time popover should show after max prompt approval
  const [pendingTimePopover, setPendingTimePopover] = useState<{
    volunteerId: string;
    sessionId: string;
  } | null>(null);

  return {
    promptVolunteerId,
    setPromptVolunteerId,
    promptSessionId,
    setPromptSessionId,
    hidePromptForDate,
    setHidePromptForDate,
    pendingTimePopover,
    setPendingTimePopover,
  };
};

export const useSharedPromptState = () => useBetween(usePromptState);
